/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0BinaryUploadDocumentsPost$Params {
      body?: {
'ConstructionSite'?: string;
'FolderId'?: string;
'File'?: Blob;
'FileName'?: string;
'DisplayName'?: string;
'SizeInBytes'?: number;
'CompanyId'?: string;
'MachineId'?: string;
'UserId'?: string;
'IsProfilePicture'?: boolean;
'ConstructionDayReportId'?: string;
}
}

export function apiV0BinaryUploadDocumentsPost(http: HttpClient, rootUrl: string, params?: ApiV0BinaryUploadDocumentsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0BinaryUploadDocumentsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0BinaryUploadDocumentsPost.PATH = '/api/v0/binary/uploadDocuments';
